import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from 'shared/components/ui/use-toast';
import { AssistantActionCreatePortfolioType } from 'types/AssistantTypes';
import ExcelPastTwoColumns from './ExcelPastTwoColumns';

type ExcelPastTwoColumnsWrapperProps = {
  messagePortfolioCast: AssistantActionCreatePortfolioType;
  onActionSubmit: (actionId: string, threadId: string, data: any) => Promise<void>;
};

export const ExcelPastTwoColumnsWrapper: React.FC<ExcelPastTwoColumnsWrapperProps> = ({
  messagePortfolioCast,
  onActionSubmit,
}) => {
  const { t } = useTranslation();
  const { toast } = useToast();

  // Intercept the submission and use our SDK logic
  const submitAction = useCallback(
    async (threadId: string, actionId: string, data: any) => {
      try {
        await onActionSubmit(actionId, threadId, data);

        toast({
          title: t('global.success'),
          description: t('assistant.manualPortfolioSuccess'),
        });
      } catch (error) {
        console.error('Action submission failed:', error);
        toast({
          title: t('global.error'),
          description: t('global.errorOccurred'),
          variant: 'destructive',
        });
        throw error;
      }
    },
    [onActionSubmit, t, toast],
  );

  return <ExcelPastTwoColumns messagePortfolioCast={messagePortfolioCast} onSubmit={submitAction} />;
};
